import { useEffect } from 'react';

const usePreventNumberInputScroll = (): void => {
  useEffect(() => {
    const handleWheel = (event: WheelEvent): void => {
      const { target } = event;

      // Check if target is an HTMLInputElement with type number
      if (target instanceof HTMLInputElement && target.type === 'number') {
        event.preventDefault();
        return;
      }

      // Check if target is an HTMLElement and find closest number input
      if (target instanceof HTMLElement) {
        const numberInput = target.closest('input[type="number"]');
        if (numberInput) {
          event.preventDefault();
        }
      }
    };

    document.addEventListener('wheel', handleWheel, { capture: true, passive: false });

    return () => {
      document.removeEventListener('wheel', handleWheel, { capture: true });
    };
  }, []);
};

export default usePreventNumberInputScroll;
